import { MOCK_POWERS, withoutAcePowers } from '@/lib/powers-data';
import type { AllpowersRequiredPower } from '@/lib/allpowers-data';

/** Fallback local quando a API FairTrade não responde. */
export function getAllpowersCatalogFallback(): AllpowersRequiredPower[] {
  return withoutAcePowers(MOCK_POWERS)
    .filter((power) => power.categories?.includes('is_allpowers'))
    .map((power) => ({
      id: power.id,
      name: power.name,
      slug: power.slug,
      category: power.category,
      limited: power.limited,
    }))
    .sort((a, b) => b.id - a.id);
}
